var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div id=\"{{ :: $ctrl.calendarId }}\" class=\"input-group\"> <div type=\"text\" date-range-picker inline=\"true\" ng-i18next=\"[placeholder]reservation_tickets.input_placeholder_text\" id=\"daterange-input\" name=\"daterange\" class=\"date-picker\" options=\"$ctrl.daterangeOptions\" ng-model=\"$ctrl.ngModel\"> </div> </div>";
var id1="winresReservationCalendar.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationCalendar/winresReservationCalendar.html
// module id = 385
// module chunks = 2